<div>
  Wollen Sie den Benutzer <strong>{{data.name}} {{data.surname}}</strong> wirklich löschen?
</div>
<div mat-dialog-actions class="flex-end">
  <button (click)="deleteUser()" color="warn" mat-raised-button>Löschen</button>
  <button [mat-dialog-close]="" mat-raised-button>Abbrechen</button>
</div>
